import {
  GET_PAGES,
  GET_PAGES_SUCCESS,
  CLEAR_ACTUAL_PAGE_ID,
} from "./constants"

const initialState = {
  list: [],
  pagePermissions: [],
  folders: [],
  idActualPage: "",
}

//

function pageListReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_PAGES_SUCCESS:
      return {
        ...state,
        list: payload.pages,
        pagePermissions: payload.permissions,
        folders: payload.folders,
      }
    case CLEAR_ACTUAL_PAGE_ID:
      return {
        ...state,
        idActualPage: "",
      }
    default:
      return state
  }
}

export default pageListReducer
